/**
 * This handles landing page operations
 */
 window._smpr = window._smpr || {};

 window._smpr.submit_data = function () {
 
     var init = function () {

        $(window).on("load", function () {
            $('.submit-data').on('click', function(){
                $('#contact-form').trigger('submit');
            });
            
            $('#contact-form').validate({
                rules: {
                    name: {
                        required: true,
                        email: false,
                        minlength: 2,
                        maxlength: 50
                    },
                    email: {
                        required: true,
                        email: true
                    },
                    message: {
                        required: true,
                        email: false,
                        minlength: 10,
                        maxlength: 200
                    }
                },
                messages: {
                    name: {
                        required: "Please enter your name",
                        minlength: "Name length should be minimum 2 characters",
                        maxlength: "Name length should be maximum 50 characters",
                    },
                    email:  {
                        required: "Please enter your email address"
                    },
                    message: {
                        required: "Let us know anything you need to know",
                        minlength: "Message length should be minimum 10 characters",
                        maxlength: "Message length should be maximum 200 characters",
                    },
                    
                },
                submitHandler: function(form) {
                    if (grecaptcha.getResponse()) {
                        form.submit();
                    } else {
                        alert('Please confirm captcha to proceed');
                    }
                }
            });

         });
     };
 
     var oPublic = {
         init: init
     };
 
     return oPublic;
 
 }();
 
 window._smpr.submit_data.init();